/** Final confirmation before marking an appointment as finished. */
export function FinishAppointmentModal({
  isOpen,
  isSubmitting,
  onClose,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal DeleteModal">
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <button
          aria-label="Close finish confirmation"
          className="CloseButton"
          onClick={onClose}
          type="button"
        />
        <h3>Are you sure you want to finish this appointment?</h3>
        <ul className="ButtonList">
          <li>
            <button
              className="ModalCloseBtn configPage"
              disabled={isSubmitting}
              onClick={onConfirm}
              type="button"
            >
              {isSubmitting ? "Please wait..." : "Yes"}
            </button>
          </li>
          <li>
            <button className="CancelBtn" onClick={onClose} type="button">
              No
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}
